import { LogTypes } from '@audibene/ta-browser-tracker'
import { styled } from '@mui/material/styles'
import { Component } from 'react'
import { Environment } from '../../constants'
import { logRocket } from '../../startup'
import { logFactory } from '../../util'
import i18next from 'i18next'

interface State {
  error?: any
}

const log = logFactory('ErrorBoundary')
const isProduction = process.env.NODE_ENV === Environment.PRODUCTION

const Container = styled('div')`
  display: grid;
  margin: 1rem;
  padding: 0;
  place-items: center;

  & * h1,
  h2,
  h3 {
    margin: 0;
    padding: 0;
  }

  & pre {
    margin-top: 2rem;
  }
`

class ErrorBoundary extends Component {
  constructor(props: any) {
    super(props)
  }

  state: State = {
    error: undefined,
  }

  componentDidCatch(error: any) {
    try {
      log('💥 Sending error to LogRocket...')
      logRocket?.log(LogTypes.ERROR, error.message, { error })
      log('💥 Successfully sent error to LogRocket')
    } catch (e) {
      console.error('Failed to log error', e)
    } finally {
      this.setState({ error })
    }
  }

  render() {
    const { error } = this.state

    if (error) {
      return (
        <Container>
          <h1>{i18next.t('pages.errorBoundary.message')}</h1>
          <h2>¯\_(ツ)_/¯</h2>
          {!isProduction && <pre>{error.toString()}</pre>}
        </Container>
      )
    }

    const { children } = this.props

    return children
  }
}

export { ErrorBoundary }
